// extracted by css-extract-rspack-plugin
export default {"cardButton":"ncWxy3j9eqojpn6S","card":"MeFBz4_b3OABx90W","menuButton":"ZAuXa3oOcDAPyuke","info":"pZwWBtOdMI9GVHiV"};